import { render, staticRenderFns } from "./BulkForm.vue?vue&type=template&id=4f31f97c&scoped=true&"
import script from "./BulkForm.vue?vue&type=script&lang=js&"
export * from "./BulkForm.vue?vue&type=script&lang=js&"
import style0 from "./BulkForm.vue?vue&type=style&index=0&id=4f31f97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31f97c",
  null
  
)

export default component.exports